// --- Modules
import Node, { payload } from './Node';

class NetworkNode extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Network Node'
    });
  }
};

export default {
  create: (opts) => {
    let item = new NetworkNode(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
